import HotelInsertionForm from "./components/hotel/HotelInsertionForm";
import { useHotelInsertion } from "./hooks/useHotelInsertion";
import { ArrowLeft, Save, Loader2, Building2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * PublicNewHotel page — renders the hotel insertion form for public registration.
 * Route: /register-hotel
 */
const PublicNewHotel = () => {
  const { hotelRequest, setHotelRequest, handleSave, loading } =
    useHotelInsertion();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAFAFA] dark:bg-slate-950 p-4 md:p-8 flex flex-col items-center">
      <div className="w-full max-w-5xl animate-fadeIn pb-10">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate("/desklogin")}
              className="p-2.5 text-slate-500 hover:text-blue-600 hover:bg-white dark:hover:bg-slate-800 hover:shadow-sm rounded-xl transition-all border border-transparent hover:border-slate-200 dark:hover:border-slate-700"
            >
              <ArrowLeft size={18} />
            </button>
            <div className="flex items-center gap-3">
              <div className="p-2 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                <Building2 size={24} className="text-blue-600 dark:text-blue-400" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-slate-800 dark:text-slate-100 tracking-tight">
                  Hotel Registration
                </h1>
                <p className="text-slate-500 dark:text-slate-400 font-semibold uppercase tracking-widest text-[10px] mt-0.5">
                  Register your property to join the OneDesk network.
                </p>
              </div>
            </div>
          </div>
          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={handleSave}
              disabled={loading}
              className="h-12 px-6 bg-blue-600 dark:bg-blue-500 hover:bg-blue-700 dark:hover:bg-blue-600 text-white font-bold rounded-xl flex items-center justify-center gap-2 transition-all shadow-sm active:scale-[0.98] disabled:bg-slate-200 dark:disabled:bg-slate-800 disabled:text-slate-400 dark:disabled:text-slate-600 disabled:shadow-none uppercase tracking-widest text-xs"
            >
              {loading ? (
                <Loader2 className="animate-spin" size={18} />
              ) : (
                <Save size={16} />
              )}
              {loading ? "Registering..." : "Register Hotel"}
            </button>
          </div>
        </div>

        {/* Form Content */}
        <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-slate-200 dark:border-slate-800 p-6 md:p-6">
          <HotelInsertionForm
            hotelRequest={hotelRequest}
            setHotelRequest={setHotelRequest}
          />
        </div>

        {/* Mobile Save Button */}
        <div className="md:hidden mt-8">
          <button
            onClick={handleSave}
            disabled={loading}
            className="w-full h-12 bg-blue-600 dark:bg-blue-500 hover:bg-blue-700 dark:hover:bg-blue-600 text-white font-bold rounded-xl flex items-center justify-center gap-2 transition-all shadow-sm active:scale-[0.98] disabled:bg-slate-200 dark:disabled:bg-slate-800 disabled:text-slate-400 dark:disabled:text-slate-600 disabled:shadow-none uppercase tracking-widest text-xs"
          >
            {loading ? (
              <Loader2 className="animate-spin" size={18} />
            ) : (
              <Save size={16} />
            )}
            {loading ? "Registering..." : "Register Hotel"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PublicNewHotel;
